import React, { useEffect, useState } from 'react';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { Table, Button, Modal, Form, Alert } from "react-bootstrap";
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import Titulo from '../elements/Titulo';
import { Helmet } from 'react-helmet';
import Pagination from './Pagination';
import AlertModal from './AlertModal';
import useAlertModal from '../hooks/useAlertModal';

const StockManagment = () => {

  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [newStock, setNewStock] = useState("");
  const [motivo, setMotivo] = useState("");
  const [newProductStock, setNewProductStock] = useState("");
  const [newProductPrice, setNewProductPrice] = useState("");
  const [products, setProducts] = useState([]);
  const filteredProducts = products.filter((product) =>
    product.item_description.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const { showAlert, showAlertModal, alertMessage, alertType, hideAlert } = useAlertModal();
  const [message, setMessage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(products.length / itemsPerPage);





  useEffect(() => {
    getStockItems();
  }, [])

  const getStockItems = async (page) => {
    await dotoniwoofApi.get(`/stock.php`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setProducts(responseApi.message);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
        }
      )
  };

  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
  const sortItems = [...currentItems].sort((a, b) => {
      return a.item_description.localeCompare(b.item_description);
  });
  

  const handleUpdateStock = (product) => {
    setSelectedProduct(product);
    setNewStock(product.stock); // Prellenar con el stock actual
    setShowModal(true);
  };

  const handleStockAdd = (product) => {
    setSelectedProduct(product);
    setNewProductPrice(product.price);
    setNewProductStock(product.stock);  // Prellenar con el stock actual
    setShowModalAdd(true);
  };

  const handleSaveStock = () => {
    if (!motivo.trim()) {
      showAlert("El motivo del ajuste es obligatorio", "danger");
      return;
    }
    const updatedProducts = products.map((product) =>
      product.id === selectedProduct.id
        ? { ...product, stock: newStock }
        : product
    );
    setProducts(updatedProducts);
    setShowModal(false);
    updateProduct(selectedProduct);
  };


  const handleSaveStockAdd = () => {
    setShowModalAdd(false);
    createNewItem(selectedProduct);
  };



  const createNewItem = async (selectedProduct) => {
    await dotoniwoofApi.post(`/stock.php`,
      JSON.stringify({
        firebase_UID: user.uid,
        id_item: selectedProduct.id_item,
        id_supplier: selectedProduct.id_supplier,
        stock: newProductStock,
        price: newProductPrice
      })
    ).then((res) => {
      if (res.status == 201) {
        showAlert("Registro creado con éxito", 'success');
        getStockItems();
      }
    })

      .catch(err => {
        console.log(err);
      }).finally(
        () => {
        }
      )
  }

  const updateProduct = async (selectedProduct) => {
    await dotoniwoofApi.put(`/stock.php/${selectedProduct.id_pricing}`,
      JSON.stringify({
        firebase_UID: user.uid,
        stock: newStock,
        motivo: motivo.trim()
      })
    ).then((res) => {
      if (res.status == 204) {
        showAlert("Registro actualizado con éxito", 'success');
        setMotivo("");
        getStockItems();
      }
    })
      .catch(err => {
        if (err.response?.status === 422) {
          showAlert("El motivo del ajuste es obligatorio", "danger");
        } else {
          console.log(err);
        }
      })
  }


  return (
    <>
      <NavContainer></NavContainer>
      <OffCanvasNav></OffCanvasNav>
      <Helmet><title>
        Administración de stock
      </title></Helmet>

      <div className="container mt-4">
        <Titulo>Administración de stock</Titulo>
        <br></br>


        {/* Input para filtrar productos */}
        <Form.Control
          type="text"
          placeholder="Buscar producto..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-3"
        />
         <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    paginate={paginate}
                />
                <br></br>
        {/* Tabla con productos filtrados */}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Producto</th>
              <th>Stock</th>
              <th>Color</th>
              <th>Talla</th>
              <th>Peso</th>
              <th>Precio</th>
              <th>Fecha Actualización</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortItems.map((product) => (
              <tr key={product.id_pricing}>
                <td>{product.item_description}</td>
                <td>{product.stock}</td>
                <td>{product.color}</td>
                <td>{product.size}</td>
                <td>{product.weight}</td>
                <td>{product.price}</td>
                <td>{product.effective_date}</td>
                <td>
                  <Button style={{ margin: '2px' }}
                    variant="primary"
                    onClick={() => handleUpdateStock(product)}
                  >
                    Actualizar Stock
                  </Button>
                  <Button style={{ margin: '2px' }}
                    variant="success"
                    onClick={() => handleStockAdd(product)}
                  >
                    Agregar con otro precio
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>


        {/* Modal para actualizar el stock */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Actualizar Stock</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Producto</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedProduct?.item_description}
                  readOnly
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Nuevo Stock</Form.Label>
                <Form.Control
                  type="number"
                  value={newStock}
                  onChange={(e) => setNewStock(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>Motivo del ajuste <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ej: inventario físico, merma, corrección de error..."
                  value={motivo}
                  onChange={(e) => setMotivo(e.target.value)}
                  data-testid="input-motivo"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => { setShowModal(false); setMotivo(""); }}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSaveStock}>
              Guardar Cambios
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modal para actualizar el stock */}
        <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Nuevo precio</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Producto</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedProduct?.item_description}
                  readOnly
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Nuevo Precio</Form.Label>
                <Form.Control
                  type="number"
                  onChange={(e) => setNewProductPrice(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Nuevo Stock</Form.Label>
                <Form.Control
                  type="number"
                  onChange={(e) => setNewProductStock(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModalAdd(false)}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSaveStockAdd}>
              Guardar Cambios
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

            {/* Modal de Alerta Temporal */}
            <AlertModal
                show={showAlertModal}
                onHide={hideAlert}
                message={alertMessage}
                type={alertType}
            />
        </>
    );
}

export default StockManagment;